import { useAppStore } from "@hooks/useAppStore";
import { useAppTemplate } from "@hooks/useAppTemplate";
import { isWeb } from "@memorang/helpers/platform";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { buildBottomTabs } from "./helpers";

export const useBottomTabs = () => {
	const navigationRoutes = useAppStore(
		(store) => store.navigation?.routes.main,
	);
	const showStudyPackAsHome = useAppStore((store) => store.showStudyPackAsHome);
	const practiceTestEnabled = useAppStore(
		(store) => store.exam.practiceTest.enabled,
	);
	const practiceTestLabel = useAppStore((s) => s.exam.practiceTest?.label);
	const { isCmeApp } = useAppTemplate();
	const { t } = useTranslation();

	return useMemo(
		() =>
			buildBottomTabs({
				navigationRoutes: navigationRoutes ?? [],
				showStudyPackAsHome: !!showStudyPackAsHome,
				practiceTestEnabled,
				practiceTestLabel,
				isWebPlatform: isWeb,
				isCmeApp,
				t,
			}),
		[
			navigationRoutes,
			showStudyPackAsHome,
			practiceTestEnabled,
			practiceTestLabel,
			isCmeApp,
			t,
		],
	);
};
